import { render, staticRenderFns } from "./RegisterVerification.vue?vue&type=template&id=29a612e4&scoped=true"
import script from "./RegisterVerification.vue?vue&type=script&lang=js"
export * from "./RegisterVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a612e4",
  null
  
)

export default component.exports